// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'

// 导入iview
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
import './assets/scss/public.scss'

import App from './App'
import routes from './router'
import PagesMapper from './pages-mapper'
import ComponentsMapper from './components-mapper'
import API from './api'
import Utils from './utils'
import { STORE_KEY } from './constants'
import APIConfig from './config'

import { RouterWatcher } from 'xbed-watcher'
import PageCodes from './pageCodes'

import tinymce from 'xbed-editor'
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
Vue.component('tinymce', tinymce)

Vue.use(iView)
Vue.use(VueRouter)
Vue.directive('has', {
    bind: function(el, binding) {
        if (!Utils.hasPermission(binding.value.permission)) {
            el.parentNode.removeChild(el)
        }
    }
})

Vue.config.productionTip = false

/**
 * 提供给旧oms使用
 */
window.xbedVue = {
    // vue 实例，提供给ng使用
    vueInstance: Vue,
    /**
     * 根据domId和组件名称，在angular上实例化vue组件使用
     * @param domId dom节点id
     */
    initComponent: (componentName, domId, propsData = {}) => {
        return new Vue({
            el: `#${domId}`,
            propsData,
            render: h => h(ComponentsMapper[componentName])
        })
    },
    // 根据moduleId 初始化vue页面
    init: (moduleName, moduleId) => {
        const pageConfig = PagesMapper[moduleName][moduleId]
        return new Vue({
            el: pageConfig.dom,
            render: h => h(pageConfig.page)
        })
    },
    // 登录接口，从gateway api 进行登录
    login: async (username, password, callback) => {
        try {
            let env = Utils.findFromLocalStorage('env', 'dev')
            let headerENV = Utils.aliHeaderEnv(env)
            if (!env) {
                throw new Error('env 不存在')
            }
            const resp = await API.omsAPI[env].user.login(username, password)
            if (resp.data.user) {
                // 调用阿里login
                let respAli = (await API.omsAPI[env].clientServer.gatewayAliLogin({username:username,password:password},{'x-ca-stage':headerENV,'X-Client-Type':5})).data;
                if(respAli.user){ //调用成功  
                    if (resp.data.token) Utils.saveToLocalStorage('vue-token', resp.data.token)
                    if (resp.data.user.id) Utils.saveToLocalStorage('vue-userid', resp.data.user.id)
                    if (resp.data.user.username) Utils.saveToLocalStorage('vue-username', resp.data.user.username)
                    const userPermissions = Utils.parsePermissions(resp.data.menuList)
                    Utils.setToStore(STORE_KEY.STORE_KEY_PERMISSIONS, userPermissions) // 把用户权限保存
                    Utils.saveToLocalStorage("Author-token", respAli.token);
                    
                    if (callback) {
                        callback(null, resp.data)
                    }
                }else {
                    callback(new Error('登录失败'))
                }
            } else {
                callback(new Error(resp.data.msg))
            }
        } catch (error) {
            throw error
        }
    },
    logout: async () => {
        try {
            let env = Utils.findFromLocalStorage('env', 'dev')
            if (!env) {
                throw new Error('env 不存在')
            }
            const token = Utils.findFromLocalStorage('vue-token',false)
            const userName = Utils.findFromLocalStorage('vue-username',false)
            console.info(token)
            if(!token) throw new Error('token 不存在')
            await API.omsAPI[env].user.logout({userName},token)
        } catch (error) {
            throw error
        }
    },
    // 获取xbed api
    getAPI: () => {
        let env = Utils.findFromLocalStorage('env', 'dev')
        return API.omsAPI[env]
    },
    // 开启统计
    startWatcher: () => {
        const env = Utils.findFromLocalStorage('env', 'dev')
        const routerWatch = new RouterWatcher({
            pageCodes: PageCodes,
            debugMode: false,
            apiConfig: {
                gatewayUrl: APIConfig[env].gatewayAPI,
                edition: 'v1.0',
                goods: 'XbedWatcher',
                terrace: 'XbedWatcher'
            }
        });
        routerWatch.start();
    },
    envConfig: APIConfig,
    hasPermission: Utils.hasPermission,
    currEnv: () => Utils.findFromLocalStorage('env', 'dev')
}

// 路由
const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    if (to.path === '/login' || to.path.match('components') || Utils.authValid()) {
        next()
    } else {
        next({ path: '/login' })
    }
})

/* eslint-disable no-new */
if (!window.xbedconfig) {
    new Vue({
        el: '#app',
        router,
        template: '<App/>',
        components: { App }
    })
}


// WEBPACK FOOTER //
// ./src/main.js